import type { TreatStatusDto } from "@boomap/contracts";

import { spotIconDataUri } from "../map/spot-icon-svg.ts";

export interface SpotIconProps {
  readonly treats: TreatStatusDto;
  readonly size?: number;
}

/**
 * La même silhouette que sur la carte, dans le DOM. Décorative : le libellé
 * textuel est toujours à côté, donc l'image est masquée aux lecteurs d'écran.
 */
export const SpotIcon = ({ treats, size = 24 }: SpotIconProps): React.ReactElement => (
  <img
    className="spot-icon"
    src={spotIconDataUri(treats)}
    width={size}
    height={size}
    alt=""
    aria-hidden="true"
    draggable={false}
  />
);
